import { render, staticRenderFns } from "./ResourceLibNew.vue?vue&type=template&id=b7f35a8c&scoped=true"
import script from "./ResourceLibNew.vue?vue&type=script&lang=js"
export * from "./ResourceLibNew.vue?vue&type=script&lang=js"
import style0 from "./ResourceLibNew.vue?vue&type=style&index=0&id=b7f35a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f35a8c",
  null
  
)

export default component.exports